import QuestionBlock from "./question-block/QuestionBlock";
import { useForm } from "@context/FormContext";
import { reindexAllQuestions } from "@utils/formUtils";

export default function QuestionManager({
  activeTabId,
  setQuestionIdCounter,
}) {
  const { tabs, setTabs } = useForm();

  const onDelete = (id) => {
    const updatedTabs = tabs.map((tab) => {
      if (tab.id === activeTabId) {
        return {
          ...tab,
          content: tab.content.filter((q) => q.id !== id),
        };
      }
      return tab;
    });
    const reindexed = reindexAllQuestions(updatedTabs);
    setTabs(reindexed);
    setQuestionIdCounter(reindexed.flatMap((t) => t.content).length + 1);
  };

  const onUpdate = (id, updated) => {
    const updatedTabs = tabs.map((tab) =>
      tab.id === activeTabId
        ? {
            ...tab,
            content: tab.content.map((q) =>
              q.id === id ? { ...q, ...updated } : q
            ),
          }
        : tab
    );
    setTabs(updatedTabs);
  };

  const activeTab = tabs.find((tab) => tab.id === activeTabId);
  const lastQuestionId = activeTab?.content[activeTab.content.length - 1]?.id;

  return (
    <div className="mt-6 pb-40">
      {activeTab?.content.map((q) => (
        <QuestionBlock
          key={q.id}
          question={q}
          collapseTrigger={0}
          onDelete={onDelete}
          onUpdate={onUpdate}
          lastAddedId={lastQuestionId} 
        />
      ))}
    </div>
  );
}
